// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FLqj","index":"styles_index__2boGG"};